import { EditOutlined } from '@ant-design/icons'
import { Button, Modal, Tooltip } from 'antd'
import React from 'react'
import { compose, withHandlers, withState } from 'recompose'

import { FlightId } from '../../schemas/Flight'
import { Playground } from '../../schemas/Playground'
import { TenantId } from '../../schemas/Tenant'
import { TournamentId } from '../../schemas/Tournament'

import FlightResults from '../tournament/FlightResults'

type FlightResultsModalOuterProps = {
  tenant: TenantId
  tournamentId: TournamentId
  flightId: FlightId
  playground: Playground
}

type FlightResultsModalInnerProps = FlightResultsModalOuterProps &
  WithModalVisible &
  WithModalHandlers

const FlightResultsModal = ({
  modalVisible,
  hideModal,
  showModal,
  tenant,
  tournamentId,
  flightId,
  playground,
}: FlightResultsModalInnerProps) => (
  <React.Fragment>
    <Tooltip title="Edit results">
      <Button size="small" icon={<EditOutlined />} onClick={showModal} />
    </Tooltip>
    {modalVisible && (
      <Modal visible={modalVisible} onCancel={hideModal} footer={null} width={760}>
        <FlightResults
          tenant={tenant}
          tournamentId={tournamentId}
          flightId={flightId}
          playground={playground}
          onCancel={hideModal}
          afterSave={hideModal}
        />
      </Modal>
    )}
  </React.Fragment>
)

// TODO unify with DevicePairing
type WithModalVisible = {
  modalVisible: boolean
}

type WithModalHandlers = {
  hideModal(): void
  showModal(): void
}

export default compose<FlightResultsModalInnerProps, FlightResultsModalOuterProps>(
  withState('modalVisible', 'setModalVisible', false),
  withHandlers({
    hideModal: ({ setModalVisible }) => () => setModalVisible(false),
    showModal: ({ setModalVisible }) => () => setModalVisible(true),
  }),
)(FlightResultsModal)



// WEBPACK FOOTER //
// ./src/components/flights/FlightResultsModal.tsx